import { useState } from "react";
import { ChevronDown } from "lucide-react";
import AdCard from "@/shared/components/AdCard/AdCard";
import type { ContentCatalogFolder } from "@models/contentCatalogFolder.model";

export default function FolderAccordion({ folder }: { folder: ContentCatalogFolder }) {
    const [open, setOpen] = useState(true);
    const hasChildren = folder.children.length > 0;
    const hasAds = folder.ads.length > 0;

    return (
        <div className="folder-accordion">
            <div className="folder-accordion__head" onClick={() => setOpen(!open)}>
                <span className="folder-accordion__title">{folder.name}</span>
                <span className={`folder-accordion__chevron${open ? " open" : ""}`}>
                    <ChevronDown size={16} />
                </span>
            </div>

            {open && (
                <div className="folder-accordion__body">
                    {hasChildren && folder.children.map((child) => (
                        <FolderAccordion key={child.id} folder={child} />
                    ))}
                    {hasAds && (
                        <div className="moti-store__ad-grid">
                            {folder.ads.map((ad) => (
                                <AdCard key={ad.id} ad={ad} mode="detail" menuActions={[]} hideType hideMenu />
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
